import { Config } from "../../../configurations/config";
export const ReviewLeaveApplication_API = {
	GetLeaveTypes: `${Config.server_url}${Config.api_prefix}/Leave/LeaveTypes`,
	GetDefaultUnreviewedLeaves_API: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications?SortBy=applied_date_desc`,
	GetUnreviewedLeaves_API: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications?`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications/ExportToExcel`,
	GetUnreviewedLeavesApplicationDetail: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications`,
	PatchReviewLeaveApplication: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications`,
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetAdminEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=false`,
	ApproveRejectBulkLeaveApplications: `${Config.server_url}${Config.api_prefix}/Leave/ApproveRejectBulkLeaveApplications`,
};
